import { z } from 'zod';
import { DOCUMENT_STATUTS_VERIFICATION, DOCUMENT_TYPES } from '../constants/statuses.js';
/**
 * Documents justificatifs (Sprint 3). Le fichier lui-même n'est jamais décrit
 * ici — il transite en `multipart/form-data` (voir `multer` côté API) ; ce
 * schéma valide uniquement les champs texte qui accompagnent l'upload.
 */
export const DOCUMENT_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
export const DOCUMENT_MAX_SIZE_OCTETS = 10 * 1024 * 1024; // 10 Mo
export const uploadDocumentMetadataSchema = z.object({
    typeDocument: z.enum(DOCUMENT_TYPES),
    numeroDocument: z.string().max(60).optional(),
    autoriteEmettrice: z.string().max(160).optional(),
    dateEmission: z.coerce.date().optional(),
    dateExpiration: z.coerce.date().optional(),
});
export const updateDocumentVerificationSchema = z.object({
    statutVerification: z.enum(DOCUMENT_STATUTS_VERIFICATION),
    commentaireVerification: z.string().max(2000).optional(),
});
//# sourceMappingURL=documents.js.map